import { Box, Button, Typography, useTheme } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import { usePWAInstallPrompt } from '../hooks/usePWAInstallPrompt';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { praharTextColorSelector } from '../../redux/slices/praharSlice';

const InstallPWA = ({ isDesktop }: { isDesktop: boolean }) => {
  const theme = useTheme();
  const router = useRouter();
  const grayPages = [
    '/go-premium',
    '/gift',
    '/refunds-and-cancellations',
    '/terms-and-conditions',
    '/privacy-policy',
    '/disclaimer',
    '/redeem',
    '/for-artists',
    '/login',
  ];
  const specialTabPaths = ['/prahar', '/browse', '/favourites'];
  const isSpecialTab = specialTabPaths.includes(router.pathname);
  // Get the prahar text color from Redux
  const praharTextColor = useSelector(praharTextColorSelector);
  const { asPath } = useRouter();
  const isPraharPage = asPath.includes('/prahar');
  const praharTextColorValue = isPraharPage ? praharTextColor : '#fff';

  const isGrayPage = grayPages.includes(router.pathname);
  const iconColor = isGrayPage
    ? theme.ragyaPalette.gray8
    : praharTextColorValue;
  const { isInstallable, promptInstall } = usePWAInstallPrompt();
  return (
    <>
      {isInstallable && (
        <Box>
          {isDesktop && (
            <Button
              component='a'
              target='_blank'
              rel='noopener noreferrer'
              size='small'
              sx={{
                color: 'white',
                borderRadius: '20px',
                textTransform: 'none',
                px: 2,
                py: 0.5,
                backgroundColor: 'rgba(255,255,255,0.01)',
                backdropFilter: 'blur(15px)',
              }}
              onClick={promptInstall}
            >
              <Typography
                sx={{
                  fontWeight: '500',
                  pr: '10px',
                  color: iconColor,
                }}
              >
                Install
              </Typography>
              <GetAppIcon sx={{ color: iconColor }} />
            </Button>
          )}
          {!isDesktop && (
            <Box
              display='flex'
              alignItems='center'
              justifyContent='center'
              borderRadius='50%'
              p='10px'
              sx={{
                backgroundColor: isSpecialTab
                  ? 'rgba(255,255,255,0.01)'
                  : 'transparent',
                backdropFilter: isSpecialTab ? 'blur(15px)' : 'none',
                cursor: 'pointer',
              }}
              onClick={promptInstall}
              tabIndex={0}
              role='button'
              aria-label='Install Ragya app'
            >
              <GetAppIcon sx={{ color: iconColor }} />
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default InstallPWA;
